<template>
  <div
    :class="['flex aspect-square items-center justify-center rounded-full shadow-sm', Color]"
    v-text="Initials"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
/// Setup
const props = defineProps({
  uid: { type: String, default: '' },
  name: { type: String, default: '' },
});
/// Data
// Brand hex values pulled from apps/public-ui/src/styles/theme.css. Pool index is the char-code
// sum of the user's AAD object id mod the pool length — same user always lands on the same color.
const COLORS = [
  'bg-[#1052aa] text-gray-100',
  'bg-[#fe3e3e] text-gray-100',
  'bg-[#feae40] text-gray-900',
  'bg-[#4e847e] text-gray-100',
  'bg-[#257d26] text-gray-100',
];
/// Computed
const Initials = computed(
  () =>
    props.name
      ?.split(' ')
      .map((x) => x.charAt(0))
      .slice(0, 2)
      .join('')
      .toUpperCase() || '',
);
const Color = computed(() => {
  const sum = [...(props.uid || '')].reduce((a, c) => a + c.charCodeAt(0), 0);
  return COLORS[sum % COLORS.length];
});
</script>
